import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { AuthStorageService, BaseSiteService, TranslationService, UserIdService } from '@spartacus/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface GetMyAccountInfoPayload {
  currentPage?: number;
  pageSize?: number;
  sort?: string;
}

@Injectable({
  providedIn: 'root',
})
export class MyaccountInfoService {
  tokenId: any;
  baseSite$: Observable<string> = this.baseService.getActive();
  userCurrent$: Observable<string> = this.auth.getUserId();
  baseSiteId: any;
  isMyAccountInfoDetailsLoaded = new BehaviorSubject<boolean>(false);
  constructor(
    protected http: HttpClient,
    protected auth: UserIdService,
    protected authStorageService: AuthStorageService,
    protected baseService: BaseSiteService,
    protected translation: TranslationService,
    private meta: Meta
  ) {}

  get userCurrent(): string {
    let userCurrent = '';
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }

  getMyAccountInfo(): Observable<any> {
    const occURL = this.meta.getTag('name=occ-backend-base-url');
    this.authStorageService
      .getToken()
      .pipe(map((data) => data.access_token))
      .subscribe((results: any) => {
        this.tokenId = results;
      });

    this.baseSite$.pipe(take(1)).subscribe((data) => {
      this.baseSiteId = data;
    });

    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    this.isMyAccountInfoDetailsLoaded.next(false);

    return this.http
      .get(
        `${occURL?.content}${environment.prefix}${this.baseSiteId}/users/${this.userCurrent}/management/accountInfo`,
        {
          headers,
        }
      )
      .pipe(map((data) => data));
  }
}
